import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXIconComponent } from './icon.component';

const Module = [
    UBXIconComponent
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule
    ],
    exports: [
        Module
    ],
})
export class UBXIconModule {}
